// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__fU85-","content":"RecentSearches_content__AUOpI"};